module.exports = __webpack_public_path__ + "static/04-7f70e4bfc2b51781726e8a3cc2f5d98a.jpg";